import { useDispatch, useSelector } from 'react-redux'

import { Loading, Map, NoData } from './components/widgets'

import { Box } from '@mui/material'
import { changeSelection } from '../state/map'
import { isEmpty, notDefined } from '../utils'
import { MapMenu } from './components/map/Menu'
import { ParkingView } from './components/map/ParkingView'

const layoutStyle = {
  width: '100%'
}

const contentStyle = {
  width: '100%',
  maxWidth: '600px',
  margin: '0 auto',
  padding: '8px'
}

export const MapConsite = () => {
  const { data, selected, checksum } = useSelector((state) => state?.map)
  const { loading } = useSelector((state) => state.navigation)
  const dispatch = useDispatch()
  const onSelect = (newSelect) => {
    dispatch(changeSelection({ selected: newSelect }))
  }

  return (
    <Box sx={layoutStyle}>
      <MapMenu />
      {loading
        ? <Loading />
        : (notDefined(data) || isEmpty(data))
            ? <NoData />
            : (
              <Box sx={contentStyle}>
                <Map
                  data={data}
                  checksum={checksum}
                  selected={selected}
                  onSelect={onSelect}
                />
              </Box>
              )}
    </Box>
  )
}

export const MapParking = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <MapMenu />
      <ParkingView />
    </Box>
  )
}

// Keep backward-compatible default export
export const MapHome = MapConsite
